module.exports = __webpack_public_path__ + "img/segura-icon-verde.09424a8d.svg";